import { useEffect, useState, useRef } from "react"
import { db } from "../firebase/FirebaseConfig"
import { collection, where, orderBy, query as queryFirestore, onSnapshot } from "firebase/firestore"

export const useCollection = (collectionPath, _query, _orderBy) => {
  const [documents, setDocuments] = useState(null)
  const [error, setError] = useState(null)

  // if we don't use a ref --> infinite loop in useEffect
  // _query is an array and is "different" on every function call
  const q = useRef(_query).current
  const ob = useRef(_orderBy).current

  useEffect(() => {
    let ref = collection(db, collectionPath)

    if (q) {
      ref = queryFirestore(ref, where(...q))
    }
    if (ob) {
      ref = queryFirestore(ref, orderBy(...ob))
    }

    const unsubscribe = onSnapshot(ref, snapshot => {
      let results = []
      snapshot.docs.forEach(doc => {
        results.push({...doc.data(), id: doc.id})
      });
      
      // update state
      setDocuments(results)
      setError(null)
    }, error => {
      console.log(error)
      setError('could not fetch the data')
    })

    // unsubscribe on unmount
    return () => unsubscribe()

  }, [collectionPath, q, ob])

  return { documents, error }
}